module.exports = __webpack_public_path__ + "media/images/icon-svg/download-white-4fe154c99c15f25283fcc241f650de72.svg";